const favoritesConfig = {
};

export const getFavoritesConfig = (entityName) => {
  return favoritesConfig[entityName] || null;
};

export const getGroupConfig = (entityName, groupName) => {
  const config = favoritesConfig[entityName];
  return config?.groups?.[groupName] || null;
};

export default favoritesConfig;